import DSelect, { SELECT_SIZES as _SELECT_SIZES } from './DSelect'

export const SELECT_SIZES = _SELECT_SIZES
export default DSelect
